<template>
  <div
    id="modal_stats"
    class="modal-large"
  >
    <modal
      name="stats"
      width="90%"
      height="90%"
      :click-to-close="disabled"
      @before-open="beforeOpen"
    >
      <span
        class="fermer"
        @click="$modal.hide('stats'), (disabled = true)"
      >x</span>
      <Tabs id="tab_tableau">
        <Tab title="Tableau">
          <TableauStats
            :stat-in-modal="statInModal"
            :type="type"
            :sous-type="sousType"
            :new-stat="newStat"
            :disabled="disabled"
            :generic-table-namespace="genericTableNamespace"
            @toggle-mode-edition="disabled = !disabled"
            @entity-created="newStat = !$event"
            @update-stat-in-modal="statInModal = $event"
          />
        </Tab>
        <!-- TODO: onglet Graphique ? -->
      </Tabs>
    </modal>
  </div>
</template>

<script>
import TableauStats from "@/components/stats/tableau/TableauStats.vue";

import { Tabs, Tab } from "vue-slim-tabs";

export default {
  name: "StatsModal",
  components: {
    TableauStats,
    Tabs,
    Tab,
  },
  provide() {
    return {
      collapsibleHeaderState: this.headerState,
    };
  },
  props: {
    /**
     * Définit le namespace du tableau en question des listes des statistiques en arrière-plan.
     */
    genericTableNamespace: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      statInModal: {
        filtres: {},
        tris: [],
      },
      type: null,
      sousType: null,
      newStat: false,
      disabled: true,
      headerState: { isOpen: false },
    };
  },
  methods: {
    /**
     * Configure la modale avec les données fournies lors de son ouverture.
     * @public
     * @param {Object} event Données pour la modale.
     */
    beforeOpen(event) {
      this.statInModal = event.params.stat || {
        filtres: {},
        date_start: new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          1,
        ).toLocaleDateString("en-CA"),
      };
      this.type = event.params.type;
      this.sousType = event.params.sousType;
      this.newStat = event.params.new;
      this.disabled = !this.newStat;
    },
  },
};
</script>

<style  lang="scss" scoped>
@use "@/assets/style/_mainModal.scss";
</style>
